import * as React from 'react';

import { IHistoryListProps } from '../types';
import AdminNav from '../../components/AdminNav';
import { Pagination, Icons, Search } from 'src/components';
import DateFilters from './DateFilters';
import HistoryItem from './HistoryItem';
import TableRow from '../../components/TableRow';

const HistoryList: React.FC<IHistoryListProps> = ({
  items,
  currentPath,
  isLoading,
  currentPage,
  pageCount,
  setPage,
  filterItems,
  filterDate,
}) => (
  <div className="flex bg-grey py-12">
    <AdminNav current={currentPath} />

    <div className="flex-1 px-16">
      <div className="flex justify-between items-center mb-6">
        <DateFilters onSubmit={filterDate} />
        <div className="flex items-center">
          <Search onChange={filterItems} withSubmitButton={true} />
        </div>
      </div>

      <Pagination
        className="mb-4"
        current={currentPage}
        count={pageCount || 1}
        onChange={setPage}
      />

      <TableRow
        heading={true}
        values={['Name', 'Type', 'When', 'What', 'By']}
        noEditForm={true}
      />

      {isLoading ? (
        <div className="bg-white loader loader-white h-128" />
      ) : items.length === 0 ? (
        <div className="bg-white px-3 py-4">
          <h2>
            <Icons.Circle
              character="!"
              color="secondary"
              bgFill={true}
              className="mb-2 mr-2"
            />{' '}
            No items found
          </h2>
        </div>
      ) : (
        items.map((item, index) => <HistoryItem key={index} item={item} />)
      )}

      <Pagination
        className="mt-4"
        current={currentPage}
        count={pageCount || 1}
        onChange={setPage}
      />
    </div>
  </div>
);

export default HistoryList;



// WEBPACK FOOTER //
// ./src/views/Admin/History/components/HistoryList.tsx